angular.module('dnecom')
    .controller('ProductProcessDetailsController', ["$scope", "StoreUtils", function ProductProcessDetailsController($scope, StoreUtils) {
        let ppdc = this;
        $scope.touched = false;
        ppdc.instructions = TemplateData.value('serviceProfiles');
        ppdc.selectedInstruction = null;
        if ($scope.product.instruction) {
            ppdc.selectedInstruction = JSON.stringify($scope.product.instruction);
            $scope.product.instructionText = $scope.product.instruction.instructionText;
            $scope.product.instructionSave = false;
        }
        $scope.getStoreUrl = function () {
            return StoreUtils.getUrl($scope.store, '/product/');
        };

        $scope.slugify = function (text) {
            return (text || '').toString().toLowerCase()
                .replace(/\s+/g, '-') // Replace spaces with -
                .replace(/[^\w\-]+/g, '') // Remove all non-word chars
                .replace(/\-\-+/g, '-') // Replace multiple - with single -
                .replace(/^-+/, '') // Trim - from start of text
                .replace(/-+$/, ''); // Trim - from end of text;
        };

        $scope.$on('product.touchPartials', function (event, data) {
            $scope.touched = true;
        });

        $scope.$on('product.afterSave', function (event, data) {
            if ($scope.product.instructionSave) {
                $scope.selectedInstructionObject.id = 0
                $scope.product.instructionSave = false;
            }
        });

        $scope.instructionsOptions = {
            tags: true,
        };

        $scope.instructionSelected = function () {
            let instruction = null;
            try {
                instruction = JSON.parse(ppdc.selectedInstruction);
            } catch (exc) {
                instruction = {
                    id: -1,
                    name: ppdc.selectedInstruction,
                }
            }

            if (instruction) {
                if (instruction.id === -1) {
                    ppdc.selectedInstruction = JSON.stringify(instruction);
                    ppdc.instructions.push(instruction);
                }

                $scope.selectedInstructionObject = instruction;
            }
            $scope.product.instruction = $scope.selectedInstructionObject;
            if ($scope.selectedInstructionObject.id !== -1) {
                $scope.product.instructionText = $scope.selectedInstructionObject.instructionText;
            }
        };

        $scope.onProductTitleChange = function () {
            $scope.product.properties.base.title = $scope.product.title;

            if (_.isEmpty($scope.product.slug) || $scope.product.slug.length <= 0) {
                $scope.product.slug = $scope.slugify($scope.product.title);
            }
        };

        $scope.checkInstructionsLength = () => {
            if ($scope.product.instructionText && $scope.product.instructionText.length > 1000) {
                $scope.product.instructionText = $scope.product.instructionText.substring(0, 1000);
            }
        };
    }]);
